import { FormattedMessage } from 'react-intl'

import { IconHeaderCoin } from 'components/Icons'
import { Card } from 'components/Layout'

import { NextSteps } from '../../NextSteps'
import type { Step, StepType } from '../../Step'
import type { UserMetadata } from '../../UserMetadata'
import { Content } from './Content'
import { Wrapper } from './Wrapper'

type Props = TaggedType<Step, StepType.Success> & {
	userMetadata: UserMetadata
}

export const Success = ({ userMetadata: { advisorName, otherApplicantName, applicantType } }: Props) => (
	<Wrapper>
		<Card>
			<IconHeaderCoin />
			<Content>
				<h2>
					<FormattedMessage id='flow.success.title' defaultMessage='Thank you' />
				</h2>
				<p>
					<FormattedMessage
						id='flow.success.description'
						defaultMessage='{applicantType, select,
							other { Your budget overview has been sent to {advisorName}, who will review it. }
						}'
						values={{ advisorName, applicantType }}
					/>
				</p>
				<p>
					<FormattedMessage
						id='flow.success.description2'
						defaultMessage='Nordea will process your application once all information has been received.'
					/>
				</p>
			</Content>
		</Card>

		<NextSteps applicantType={applicantType} otherApplicantName={otherApplicantName} completedStep='budget' />
	</Wrapper>
)
